import styled, { css } from "styled-components";

const Wrapper = styled.ul(({ theme }) => css`
  display: flex;
  padding-left: 0;
  padding-bottom: 12px;
  overflow-x: auto;

  .tab-item {
    padding-left: 12px;
    padding-right: 12px;
    border-bottom: 4px solid #CBCBCB;
    transition: border-bottom-color 0.2s;
    cursor: pointer;
    font-size: 16px;
    color: #878787;

    @media only screen and (min-width: ${theme.breakpoints.M}) {
      padding-left: 24px;
      padding-right: 24px;
    }

    @media only screen and (min-width: ${theme.breakpoints.S}) {
      padding-left: 40px;
      padding-right: 40px;
    }

    &:focus {
      outline: #111 dotted 0.2px;
    }

    &.active {
      border-bottom-color: ${theme.palette.main.secondary};
      font-weight: ${theme.fonts.headingWeight};
      color: ${theme.palette.main.secondary};
    }
  }

  &:after {
    flex: 1;
    content: "";
    display: block;
    justify-self: stretch;
    border-bottom: 4px solid #CBCBCB;
  }
`);

export default Wrapper;
